<template>
  <div id="faq-page">
    <!-- JUMBOTRON -->
    <div class="faq-jumbotron">
      <div class="faq-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base">
        <h1 class="mb-1 text-white">2배 빠른 영어! 말하면서 동시에 쓴다.</h1>
        <p class="text-white">토킹클래스는 매일 1시간씩 공부하는 프로그램으로 30분은 학습자 중심의 세스토플러로 INPUT 자기주도 학습을 하고 30분은 교사와 함께 점검 및 OUTPUT
          교재학습을 통해서 표현중심의 응용학습을 하게 됩니다.
        </p>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/5 lg:w-1/5">
        <vx-card>
          <div>
            <student-info/>
          </div>
          <vs-divider></vs-divider>
          <div class="mt-12">
            <banner-info />
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-3/5 lg:w-4/5 mt-4 md:mt-0">
        <vx-card title="학습 스케줄">
          <vs-collapse type="border" accordion>
            <vs-collapse-item :open="open" :key="index" v-for="(stepList, index) in scheduleList">
              <div slot="header">
                <div class="vx-row flex flex-wrap justify-between">
                  <div class="vx-col flex w-1/2 h-12">
                    <feather-icon icon="MenuIcon" svgClasses="w-5 h-5 stroke-current mr-1 text-primary"/>
                    <p class="mt-2 text-primary"><span class="font-bold">{{ displayUnitName(stepList.unit)}}</span> Lesson Plan</p>
                  </div>
                  <div class="vx-col flex w-1/2 justify-end mr-auto">
                    <vs-button type="flat" @click="onStartStudy(stepList.unit)" >이어서 학습하기</vs-button>
                  </div>
                </div>
              </div>

              <vs-table :data="stepList.schedule" stripe>
              <template slot="thead">
                <vs-th>순서</vs-th>
                <vs-th width="30%">Step</vs-th>
                <vs-th >학습진도</vs-th>
                <vs-th >진도율</vs-th>
                <vs-th ></vs-th>
                <vs-th ></vs-th>
              </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                      <p class="product-name font-medium truncate">{{ indextr + 1}}</p>
                    </vs-td>

                    <vs-td>
                      <p class="product-name font-medium truncate">{{ tr.stepName }}</p>
                    </vs-td>

                    <vs-td>
                      <p class="product-name font-medium truncate">{{ tr.studyFinishedCount }}/{{ tr.menuCount }}</p>
                    </vs-td>
                    <vs-td>
                      <vs-progress :percent="data[indextr].progress" :color="progressColor(data[indextr].progress)"  class="shadow-md" />
                    </vs-td>

                    <vs-td>
                      <vs-chip  class="product-order-status" :color="progressColor(data[indextr].progress)">{{ progressText(data[indextr].progress)}}</vs-chip>
                    </vs-td>

                    <vs-td>
                      <vs-button type="flat" @click="onStartStudy(stepList.unit, tr.stepCode)">학습하기</vs-button>
                    </vs-td>

                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
            </vs-collapse-item>
          </vs-collapse>  
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchData } from '@/api/module'
import StudentInfo  from './StudentInfo'
import BannerInfo  from './BannerInfo'

export default {
  components: {
    StudentInfo,
    BannerInfo
  },
  data () {
    return {
      userInfo: null,
      scheduleList: [],
      open: false
    }
  },
  props: {
    bookCode: String
  },
  computed: {
  },
  methods: {
    
    displayUnitName (unit) {
      if (unit === null) return
      return unit.replace('U', 'Unit ')
    },
    progressText (progress) {
      if (progress === 0) {
        return '학습전'
      } else if (progress === 100) {
        return '학습완료'
      } else {
        return '학습중'
      }
    },
    progressColor (progress) {
      if (progress === 0) {
        return 'danger'
      } else if (progress === 100) {
        return 'success'
      } else {
        return 'primary'
      }
    },
    onStartStudy (unit, step) {
      console.log(step)
      if (step === undefined) {
        this.$router.push(`/study?bookCode=${this.bookCode}&unitCode=${unit}`)
      } else {
        this.$router.push(`/study?bookCode=${this.bookCode}&unitCode=${unit}&stepCode=${step}`)
      }
    },
    arrangeData (scheduleList) {
      
      let unitCode = ''
      let stepList = new Array()
      const unitList = new Array()
      for (let i = 0; i < scheduleList.length; i++) {
        if (unitCode !== scheduleList[i].unitCode) {
          unitCode = scheduleList[i].unitCode
          if (stepList.length > 0) {
            unitList.push({unit: stepList[0].unitCode, schedule: stepList.slice()})
            stepList = new Array()
          }
          stepList.push(scheduleList[i])
        } else {
          stepList.push(scheduleList[i])
        }
      }

      if (stepList.length > 0) {
        unitList.push({unit: stepList[0].unitCode, schedule: stepList.slice()})
      }
      return unitList
    },
    async loadScheduleList () {
      try { 
        const params = {
          bookCode: this.bookCode,
          userID: this.userInfo.userID
        }
        const { data } = await fetchData('/study-contents/schedule', params)
        this.scheduleList = this.arrangeData(data.list)
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    this.loadScheduleList()

  },
  mounted () {
  },
  updated () {
    // setTimeout(function () {
    //   this.open = true
    // }.bind(this), 3000)
  } 
}

</script>

<style lang="scss">
#faq-page {
    .faq-jumbotron-content {
        background-image: url('../assets/images/pages/faq.jpg');
        background-size: cover;
    }

    .faq-bg {
        background-color: #fff;
    }
}
</style>